import React from 'react';
import { Wrapper } from './styled';
import { showModal } from '../../../../actions/modal';
import { useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import Lock from '../../../common/Lock';

const Header = styled.div`
  padding: 13px 1.5rem !important;
  margin-bottom: 18px !important;

  .subtitle {
    font-size: 16px;
  }
`;

const IntegrationBlock = (props) => {
  const {
    title,
    isChangable = true,
    modalType,
    modalData = {},
    children = <></>,
    isSaveable,
  } = props;
  const dispatch = useDispatch();

  const handleModalClick = () => {
    dispatch(showModal(modalType, { data: modalData, isSaveable: isSaveable }));
  };

  return (
    <Wrapper>
      <Header className="header card-title border-bottom border-top">
        <h4 className="subtitle">{title}</h4>
        {isChangable && (
          <>
            {isSaveable ? (
              <div className="change-link" onClick={() => handleModalClick()}>
                Изменить
              </div>
            ) : (
              <Lock reason="Изменение невозможно" />
            )}
          </>
        )}
      </Header>
      <div className="children">{children}</div>
    </Wrapper>
  );
};

export default IntegrationBlock;
